import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FormLabel } from '@/components/v4';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

/**
 * Service Category ID field. Editable in add mode; read-only once editing
 * an existing service category, since the ID can't be changed after
 * creation — same read-only-on-edit convention as TemplateIdField.
 */
const ServiceCategoryIdField = ({ darkMode, errors, touched, isEditMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired={!isEditMode}
            isInvalid={!!errors.id && touched.id}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    ID{' '}
                    {isEditMode && (
                        <span className="font-medium text-gray-400">
                            (read-only)
                        </span>
                    )}
                </FormLabel>
                <Field
                    name="id"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            placeholder="Enter service category ID"
                            darkMode={darkMode}
                            isReadOnly={isEditMode}
                            className={
                                isEditMode
                                    ? 'cursor-default !text-gray-400'
                                    : undefined
                            }
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Referenced by service profiles and vendor defined services when assigning this category. Changing it later would point existing assignments at a different value, so keep it unique."
                        ariaLabel="service-category-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.id}</FieldError>
        </FormControl>
    );
};

export default ServiceCategoryIdField;
